module.exports = __webpack_public_path__ + "static/media/80.4a6a4eda.svg";